import React from 'react';
import InlineLoadingSC from './inline-loading.styled';

const InlineLoading = ({ className }) => {
  return (
    <InlineLoadingSC className={className ? className : ''}>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
    </InlineLoadingSC>
  );
};

export default InlineLoading;
